<template>
  <div>
    <div class="news-detail">
      <span @click="gotoHome" style="cursor: pointer">首页</span>
      <span>></span>
      <span style="color: #333333">海事专栏</span>
    </div>
    <div class="cloumn-deal">
      <div class="cloumn-one">
        <div class="cloumn-title">企业报备</div>
        <!-- <div class="cloumn-font">船企海事申报填写</div> -->
        <div class="cloumn-button" @click="getDeclar">登录入口</div>
        <img src="@/assets/cloumn1.png" alt="" />
      </div>
      <div class="cloumn-two">
        <div class="cloumn-title">海事审阅</div>
        <!-- <div class="cloumn-font">海事局线上审核</div> -->
        <div class="cloumn-button" @click="getMar">登录入口</div>
        <img src="@/assets/cloumn2.png" alt="" />
      </div>
    </div>
    <div class="crewWind">
      <span>海员风采</span><span @click="morePic">查看更多></span>
    </div>
    <div class="crew-photo">
      <div class="photo-train" v-for="(item, index) in photoList" :key="index">
        <img :src="item.url" alt="" />
        <div class="photo-font">
          <span :title="item.mediaName">{{ item.mediaName }}</span>
        </div>
        <div class="photo-dec" :title="item.mediaIntroduction">
          {{ item.mediaIntroduction }}
        </div>
      </div>
    </div>
    <div class="crew-video">
      <div class="crew-title">
        <span>精彩分享</span><span @click="moreVid">查看更多></span>
      </div>
      <div class="viedo-list">
        <div
          v-for="(item, index) in viedoList"
          :key="index"
          class="viedo-one"
          @click="openViedo(item)"
        >
          <div class="viedo-img"><img :src="item.videourl" alt="" /></div>
          <div class="video-font" :title="item.mediaName">
            {{ item.mediaName }}
          </div>
          <div class="video-mess">
            <div class="video-user">海事局</div>
            <div class="video-time">{{ item.uploadTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      class="dialog-color dialog-viedo"
      width="60.7143rem"
      :title="viedoTitle"
      :visible.sync="videoVisible"
      ref="vueRef"
      :before-close="handleClose"
    >
      <div class="video-up">
        <video :src="videoUrl" autoplay controls ref="vueRef"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { selecteMediaInfo, getOneFile, getAllFile } from "@/apis/index";
//getAllFile
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      test: "",
      newsDetail: {},
      photoList: [],
      viedoList: [],
      viedoTitle: "",
      videoVisible: false,
      videoUrl: "",
      urlStr: "",
    };
  },
  mounted() {
    this.selecteVideoInfoList();
  },
  created() {
    this.selecteMediaInfoList();
  },
  methods: {
    getDeclar() {
      let data = sessionStorage.getItem("userType");
      if (!data || (data != 0 && data != 1)) {
        this.$message({
          message: "此功能未对该用户开放",
          type: "warning",
        });
      } else if (data == 0 || data == 1) {
        this.$router.push({ name: "maritimeDeclaration" });
      }
    },
    async selecteMediaInfoList() {
      let res = await selecteMediaInfo({
        mediaType: "1",
        pageSize: 8,
        pageNo: 1,
        showMedia: "1",
      });
      res.data.resultList.forEach((item) => {
        this.urlStr +=
          item.pictureUrl[0] == "/"
            ? "file" + item.pictureUrl + ","
            : "file/" + item.pictureUrl + ",";
        // this.lookAllFileSrc(this.urlStr);
        // let url = this.lookFileSrc(item.pictureUrl);
        // url.then((result) => {
        //   item.url = result;
        // });
        // item.url = url.PromiseResult.data;
      });
      let urlLists = this.lookAllFileSrc(this.urlStr);
      urlLists.then((result) => {
        this.urlList = result;
        // console.log(this.urlList);
        res.data.resultList.forEach((item, index) => {
          this.urlList.forEach((val, valIndex) => {
            if (index == valIndex) {
              item.url = val;
            }
          });
        });
      });

      // let that = this;
      // setTimeout(() => {
      this.photoList = res.data.resultList;
      // }, 500);
      // this.formPhoto = res.data;
      // console.log(this.photoList);
      // this.lookFileSrc(res.data.pictureUrl);
    },
    handleClose() {
      this.videoVisible = false;
      this.$refs.vueRef.pause(); //暂停
    },
    async selecteVideoInfoList() {
      let res = await selecteMediaInfo({
        mediaType: "2",
        pageSize: 4,
        pageNo: 1,
        showMedia: "1",
      });
      res.data.resultList.forEach((item) => {
        let url = this.lookFileSrc(item.mediaUrl);
        let videourl = this.lookFileSrc(item.pictureUrl);
        url.then((result) => {
          item.url = result;
        });
        videourl.then((result) => {
          item.videourl = result;
        });

        // item.url = url.PromiseResult.data;
      });
      let that = this;
      setTimeout(() => {
        that.viedoList = res.data.resultList;
      }, 500);
      // this.formPhoto = res.data;
      // console.log(this.photoList);
      // this.lookFileSrc(res.data.pictureUrl);
    },

    async lookFileSrc(src) {
      // console.log(src);
      let url = await getOneFile({
        fileName: src[0] == "/" ? "file" + src : "file/" + src,
      });
      return url.data;
      // console.log(url);
      // if (url) {
      //   window.open(url);
      // }
    },
    async lookAllFileSrc(src) {
      // console.log(src);
      let url = await getAllFile({
        fileNameList: src,
      });
      return url.data;
      // console.log(url);
      // if (url) {
      //   window.open(url);
      // }
    },
    gotoHome() {
      this.$router.push("/home");
    },
    openViedo(item) {
      this.viedoTitle = item.mediaName;
      this.videoUrl = item.url;
      this.videoVisible = true;
    },
    getMar() {
      let data = sessionStorage.getItem("userType");
      if (data != 2) {
        this.$message({
          message: "此功能未对该用户开放",
          type: "warning",
        });
      } else if (data == 2) {
        this.$router.push({ name: "declarationReview" });
      }
    },
    morePic() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.$router.push({ name: "sailorDemeanor" });
    },
    moreVid() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.$router.push({ name: "excitingSharing" });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
